export const TRANSLATION_GROUP_CREATIVES_LINK_TABLE = Symbol('affiliate.creatives-link.table');
export const AFFILIATE_CREATIVES_LINK_TABLE_ROUTE_NAME = Symbol('affiliate.creatives-link.table');

export const AFFILIATE_CREATIVES_LINK_TABLE_QUERY_KEY = 'affiliate-creatives-link-table';
export const AFFILIATE_CREATIVES_LINK_TABLE_API_URL = 'affiliate/get_creative_links/:formatType/list_creatives';
